module.exports = __webpack_public_path__ + "html/user-info_dac81fce0267bcb388942e6a232e1185.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/user-info.html
// module id = Ldjh
// module chunks = 154